export default __webpack_public_path__ + "static/media/9.45f8b03e.jpg";